import App from './App'

const app = new App({
	target: document.body,
})

export default app
